import { Component, Input } from "@angular/core";

@Component({
  selector: "app-one-side-image-card",
  templateUrl: "./one-side-image-card.component.html",
  styleUrls: ["./one-side-image-card.component.scss"],
})
export class OneSideImageCardComponent {
  @Input() image: string = "";
  @Input() title: string = "";
  @Input() description: string | string[] = "";
  @Input() isList: boolean = false;
  @Input() reverse: boolean = false;

  get descriptionList(): string[] {
    return Array.isArray(this.description) ? this.description : [];
  }
}
